<template>
    <div>
        <div id="micro-app"></div>
    </div>
</template>
<script>
import { start } from 'qiankun';
// import { getCookie } from '@/utils/cookie';
// import platformName from '@/common/public-platform';
export default {
    name: 'microApp',
    data() {
        return {};
    },
    methods: {},
    mounted() {
        // 下发token到子应用
        if (!window.qiankunStarted) {
            window.qiankunStarted = true;
            start({
                // fetch(url, options = {}, ...args) {
                //     if (process.env.VUE_APP_ENV === 'stable') {
                //         let urls = platformName.map(item => {
                //             return process.env[
                //                 `VUE_APP_SUB_${item.shortName.toUpperCase()}`
                //             ];
                //         });
                //         if (urls.includes(url)) {
                //             options.headers = Object.assign(
                //                 {
                //                     x_hades_env_identity:
                //                         getCookie('X-Hades-Env-Identity') ||
                //                         ''
                //                 },
                //                 options.headers
                //             );
                //         }
                //     }
                //     return window.fetch(url, options, ...args);
                // }
                excludeAssetFilter: assetUrl => {
                    const whiteList = [];
                    const whiteWords = ['cdn.ckeditor.com'];
                    if (whiteList.includes(assetUrl)) {
                        return true;
                    }
                    return whiteWords.some(w => {
                        return assetUrl.includes(w);
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped></style>
